var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-not-found"},[_c('h1',[_vm._v("Oops!")]),_c('h3',{staticClass:"margin-top-zero"},[_vm._v("\n    La página que estás buscando no está aquí.\n  ")]),_c('router-link',{staticClass:"text-color-academy-primary text-weight-bold",attrs:{"to":{ name: 'home' }}},[_vm._v("\n    Volver a la página de inicio\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }